<script lang="ts">
  import { onMount } from 'svelte';
  import type { TrustpilotRatingProps } from './types';
  import pwtHelper from '$lib/helpers/browser/pwt-helper';

  export let entryId: TrustpilotRatingProps['entryId'];
  export let url: TrustpilotRatingProps['url'];
  export let trustpilotLogoImage: TrustpilotRatingProps['trustpilotLogoImage'];
  export let ratingImage: TrustpilotRatingProps['ratingImage'];
  export let ratingText: TrustpilotRatingProps['ratingText'];
  export let noUrl: TrustpilotRatingProps['noUrl'];

  let enableTrustpilot = false;

  onMount(() => {
    // check if user allowed analytic tracking via OneTrust
    pwtHelper.subscribeDependents();
    enableTrustpilot = window.Sq.Tracking.analyticsTrackingEnabled || false;
  });
</script>

<div class="TrustpilotRating TrustpilotRating-{entryId}-box-properties" data-entry-id={entryId}>
  {#if url}
    <p>
      <a href={url} target="_blank" rel="noopener noreferrer nofollow">
        {#if enableTrustpilot && ratingImage}
          <img class="stars" src={ratingImage} alt="Trustpilot Stars" />
        {/if}
        {#if ratingText}
          <span class="ratingText">{ratingText}</span>
        {/if}
        {#if trustpilotLogoImage}
          <img class="logo" src={trustpilotLogoImage} alt="Trustpilot Logo" />
        {/if}
      </a>
    </p>
  {/if}
  {#if noUrl}
    <div class="noUrlTrustPilot">
      {#if enableTrustpilot && ratingImage}
        <img class="stars" src={ratingImage} alt="Trustpilot Stars" />
      {/if}
      {#if ratingText}
        <span class="ratingText">{ratingText}</span>
      {/if}
      {#if trustpilotLogoImage}
        <img class="logo" src={trustpilotLogoImage} alt="Trustpilot Logo" />
      {/if}
    </div>
  {/if}
</div>

<style lang="scss">
  .TrustpilotRating {
    p {
      text-decoration: none;
    }
    a,
    .noUrlTrustPilot {
      display: inline-flex;
      column-gap: 15px;
      align-items: center;
      color: var(--color-gray-80);
      font-weight: 500;

      &:visited {
        color: var(--color-gray-80);
        font-size: 18px;
      }
    }

    .ratingText,
    .stars {
      height: 30px;
      position: relative;
      top: 3px;
    }

    .ratingText {
      top: 7px;
    }

    .logo {
      height: 38px;
    }
  }
</style>
